import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { UpcomingAppointmentsQuery } from '../queries/upcoming_appointments_query';
import { AppointmentRemindersServant } from '../servants/appointment_reminders_servant';
import { LocalStorageServant } from '../servants/local_storage_servant';
import { IAppointment } from '../types/appointment_interfaces';

export class MyAppointmentsService {
  appointments: IAppointment[];
  showReminders: boolean;
  upcomingAppointments: IAppointment[];
  showNextMonthAppointmentsOnly: boolean;
  showPastAppointments: boolean;
  showAppointmentRequests: boolean;
  isUpcomingAppointmentsAvailable: boolean;
  isPastAppointmentsAvailable: boolean;
  isAppointmentsError: boolean = false;
  isApptsLoading: boolean = true;

  constructor(
    private loadUpcomingAppointmentsCommand: ICommand,
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    private ngAppointmentRemindersServant: AppointmentRemindersServant,
    private ngLocalStorageServant: LocalStorageServant
  ) {
    this.isUpcomingAppointmentsAvailable = true;
    this.isPastAppointmentsAvailable = true;
  }

  loadUpcomingAppoinments(): void {
    this.showPastAppointments = _4.isUndefined(this.showPastAppointments) ? true : this.showPastAppointments;
    this.showAppointmentRequests = _4.isUndefined(this.showAppointmentRequests) ? true : this.showAppointmentRequests;
    this.loadUpcomingAppointmentsCommand()
      .then(() => {
        this.isApptsLoading = false;
        this.isUpcomingAppointmentsAvailable =
          this.ngUpcomingAppointmentsQuery.result(this.showNextMonthAppointmentsOnly).upcomingAppointments.length > 0;
        this.isPastAppointmentsAvailable = this.ngUpcomingAppointmentsQuery.result().pastAppointments.length > 0;
        this.upcomingAppointments = !!this.showNextMonthAppointmentsOnly
          ? this.filterUpcomingAppointments()
          : this.ngUpcomingAppointmentsQuery.result().upcomingAppointments;
        const wereAppointmentgrowlersShown: boolean = !!this.ngLocalStorageServant.getItem(
          'appointment-growlers-displayed'
        );
        if (!!this.showReminders && !wereAppointmentgrowlersShown) {
          this.ngLocalStorageServant.setItem('appointment-growlers-displayed', true);
          this.ngAppointmentRemindersServant.generateUpcomingAppointmentReminders();
          this.ngAppointmentRemindersServant.generateAppointmentRequestReminders();
        }
      })
      .catch(() => {
        this.isApptsLoading = false;
        this.isAppointmentsError = true;
      })
      .finally(() => {
        this.isApptsLoading = false;
      });
  }

  filterUpcomingAppointments(): IAppointment[] {
    return _4.take<IAppointment>(
      _4.filter<IAppointment>(
        this.ngUpcomingAppointmentsQuery.result().upcomingAppointments,
        (appointment: IAppointment) => {
          const startTime: moment.Moment = moment.unix(appointment.start_timestamp);
          return startTime.diff(moment(), 'days') <= 30;
        }
      ),
      5
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/services/my_appointments_service.ts